import React from "react";
import { twMerge } from "tailwind-merge";
import PropTypes from "prop-types";

export const CheckBox = ({ labelText, id = "", wrapperClassName, checked = false, ...rest }) => {
  return (
    <div className={twMerge("inline-flex justify-start items-start", wrapperClassName)}>
      <div className="flex justify-start items-center gap-2">
        <input id={id} type="checkbox" checked={checked} aria-checked={checked} className="w-4 bg-white rounded-sm" {...rest} />
        <label htmlFor={id} className="justify-center text-neutral-700 font-normal">
          {labelText}
        </label>
      </div>
    </div>
  );
};

CheckBox.propTypes = {
  labelText: PropTypes.node.isRequired,
  id: PropTypes.string,
  checked: PropTypes.bool,
  wrapperClassName: PropTypes.string
};